import { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';

function TagNameField({ tag, index, onCommit }) {
  const [draft, setDraft] = useState(tag.name);

  useEffect(() => setDraft(tag.name), [tag.name]); // keep draft in sync if tags list changes externally

  const commit = async () => {
    const res = await onCommit(index, draft);

    if (!res || !res.ok) {
      setDraft(tag.name); // if the validation inside onCommit failed -> revert to last committed value
    } else if (typeof res.name === 'string') {
      setDraft(res.name); // if onCommit was successful -> normalize to the trimmed/committed name
    }
  };

  return (
    <Form.Control
      type="text"
      className="customizer-mobile-device-compatible-center"
      value={draft}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') e.currentTarget.blur(); // triggers onBlur
        if (e.key === 'Escape') setDraft(tag.name); // cancel edit
      }}
    />
  );
}

export default TagNameField;
